import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		background: colors.danger.light,
		border: `2px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		display: 'flex',
		gap: spacing.md,
		marginBottom: spacing.lg,
		padding: spacing.md,
	},
	icon: {
		flex: '0 0 auto',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	title: {
		color: colors.danger.dark,
		fontSize: typography.fontSizes.md,
		fontWeight: 600,
		margin: 0,
	},
	message: {
		color: colors.danger.dark,
		fontSize: typography.fontSizes.sm,
		margin: 0,
	},
});
